import { navigate } from '../router'
import { rememberScroll } from './scrollMemory'
import { useUi, type Metric, type TimeMachineTab } from '../ui'

/**
 * Every opener of the forecast page. Modules call these directly (no per-render closures, so
 * memoised modules stay memoised). Sheets rise from below; they do not morph from the module.
 */
export const openMetric = (metric: Metric, day = 0): void => useUi.getState().open({ kind: 'detail', metric, day, origin: '' })
export const openSources = (): void => useUi.getState().open({ kind: 'sources', origin: '' })
export const openTimeMachine = (tab: TimeMachineTab): void => useUi.getState().open({ kind: 'timemachine', tab, origin: '' })
export const openAlert = (alertId: string): void => useUi.getState().open({ kind: 'alert', alertId, origin: '' })
export const openSettings = (): void => useUi.getState().open({ kind: 'settings', origin: '' })
export const openMap = (query = '?layer=precip'): void => {
  rememberScroll()
  navigate(`/map${query}`)
}
export const openStudio = (): void => {
  rememberScroll()
  navigate('/studio')
}
export const openSevereMap = (): void => openMap('?layer=severe')
